import { createSlice } from "@reduxjs/toolkit";
import * as selectors from "./selectors";
import {
  DateFilterTypes,
  SetStatsFiltersAction,
  statsState,
  SetStatsDateFilterType,
  StatsFilters,
  TriggerDevicesSubscribedAndReachedRequestAction,
} from "./interfaces";
import * as extraActions from "../../extra-actions";
import * as sagas from "./sagas";
import moment from "moment";

const initialState: statsState = {
  devicesPerDayList: [],
  subscribedAndReachedPerEventList: [],
  devicesInfo: {
    os: { android: 0, ios: 0 },
    manufacturer: {},
    androidVersion: {},
    iOSVersion: {},
  },
  filters: {
    [StatsFilters.START_DATE]: moment().subtract(30, "days").format(),
    [StatsFilters.END_DATE]: moment().format(),
  },
  dateFilterType: DateFilterTypes.LAST_30_DAYS,
};

export const statsStore = createSlice({
  name: "stats",
  initialState,
  reducers: {
    setStatsDateFilterType: (state, action: SetStatsDateFilterType) => {
      state.dateFilterType = action.payload.dateFilterType;
      switch (action.payload.dateFilterType) {
        case DateFilterTypes.LAST_30_DAYS:
          state.filters[StatsFilters.START_DATE] = moment()
            .subtract(30, "days")
            .format();
          state.filters[StatsFilters.END_DATE] = moment().format();
          break;
        case DateFilterTypes.LAST_14_DAYS:
          state.filters[StatsFilters.START_DATE] = moment()
            .subtract(14, "days")
            .format();
          state.filters[StatsFilters.END_DATE] = moment().format();
          break;
        case DateFilterTypes.LAST_7_DAYS:
          state.filters[StatsFilters.START_DATE] = moment()
            .subtract(7, "days")
            .format();
          state.filters[StatsFilters.END_DATE] = moment().format();
          break;
        case DateFilterTypes.PREVIOUS_MONTH:
          state.filters[StatsFilters.START_DATE] = moment()
            .subtract(60, "days")
            .format();
          state.filters[StatsFilters.END_DATE] = moment()
            .subtract(30, "days")
            .format();
          break;
        case DateFilterTypes.LAST_90_DAYS:
          state.filters[StatsFilters.START_DATE] = moment()
            .subtract(90, "days")
            .format();
          state.filters[StatsFilters.END_DATE] = moment().format();
          break;
        case DateFilterTypes.CUSTOM:
          if (action.payload.startDate) {
            state.filters[StatsFilters.START_DATE] = moment(
              action.payload.startDate,
            ).format();
          }
          if (action.payload.endDate) {
            state.filters[StatsFilters.END_DATE] = moment(
              action.payload.endDate,
            ).format();
          }
          break;
      }
    },
    setStatsFilter: (state, action: SetStatsFiltersAction) => {
      state.filters[action.payload.statsFilter] = action.payload.value;
    },
    resetStatsFilters: (state) => {
      state.filters = {};
      state.dateFilterType = DateFilterTypes.LAST_30_DAYS;
      state.filters[StatsFilters.START_DATE] = moment()
        .subtract(30, "days")
        .format();
      state.filters[StatsFilters.END_DATE] = moment().format();
    },
    triggerDevicesSubscribedAndReachedRequest: (
      state,
      action: TriggerDevicesSubscribedAndReachedRequestAction,
    ) => {},
  },
  extraReducers: (builder) => {
    builder.addCase(extraActions.appStartup, (state) => {
      state.dateFilterType = DateFilterTypes.LAST_30_DAYS;
      state.filters = state.filters ?? {};
      state.filters[StatsFilters.START_DATE] = moment()
        .subtract(30, "day")
        .format();
      state.filters[StatsFilters.END_DATE] = moment().format();
    });
    builder.addCase(
      extraActions.getStatsMerchantsDevicesByMerchantId.success,
      (state, action) => {
        state.devicesPerDayList = action.payload.data.devicesPerDay;
      },
    );
    builder.addCase(
      extraActions.getStatsMerchantsEventsDevicesByMerchantId.success,
      (state, action) => {
        state.subscribedAndReachedPerEventList =
          action.payload.data.devicesCountPerEvent;
      },
    );
    builder.addCase(
      extraActions.getStatsMerchantsDevicesInfosByMerchantId.success,
      (state, action) => {
        state.devicesInfo = action.payload.data.devicesInfo;
      },
    );
  },
});

export { selectors, sagas };
